import { Box, Container, Grid } from '@mui/material';
import React from 'react';
import CaseNoticeForm from '../../components/case-notice-form';

const CaseNotice = () => (
  <Box
    component="main"
    sx={{
      flexGrow: 1,
      py: 8,
    }}
  >
    <Container maxWidth="lg">
      <Grid item lg={8} md={6} xs={12}>
        <CaseNoticeForm />
      </Grid>
    </Container>
  </Box>
);

export default CaseNotice;
